"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Link = void 0;
const react_1 = __importDefault(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const Link = (props) => {
    const { className, children, disabled, color, ariaDisabled, as: Component = 'a' } = props, restProps = __rest(props, ["className", "children", "disabled", "color", "ariaDisabled", "as"]);
    const linkContainerBaseClassName = 'bds-c-link-container';
    const linkContainerDisabledClassName = disabled ? `bds-is-disabled` : '';
    const linkContainerClassName = classnames_1.default(linkContainerBaseClassName, linkContainerDisabledClassName);
    const linkBaseClassName = 'bds-c-link';
    const linkDisabledClassName = disabled ? `bds-is-disabled` : '';
    const linkColorClassName = color
        ? `${linkBaseClassName}--color-${color}`
        : '';
    const linkClassName = classnames_1.default(linkBaseClassName, linkDisabledClassName, linkColorClassName, className);
    const componentProps = Object.assign({ className: linkClassName, ['aria-disabled']: disabled ? true : ariaDisabled, tabIndex: disabled ? -1 : null }, restProps);
    return (react_1.default.createElement("div", { className: linkContainerClassName },
        react_1.default.createElement(Component, Object.assign({}, componentProps), children)));
};
exports.Link = Link;
exports.default = exports.Link;
